import request from '@/utils/request'

export default{
 
  //查询订单列表
  list(currentPage, pageSize) {
    return request({
      url: '/api/order-info/list/' + currentPage + '/' + pageSize,
      method: 'get'
    })
  },

  queryOrderStatus(orderNo) {
    return request({
      url: '/api/order-info/query-order-status/' + orderNo,
      method: 'get'
    })
  },
  list1(currentPage, pageSize) {
    return request({
      url: '/api/order-info/list1/' + currentPage + '/' + pageSize,
      method: 'get'
    })
  },

  queryOrderStatus1(orderNo) {
    return request({
      url: '/api/order-info/query-order-status1/' + orderNo,
      method: 'get'
    })
  }
}
